import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiDownload, FiActivity, FiSettings, FiArrowLeft, FiHardDrive } = FiIcons;

export const AdminLayout = () => {
  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <aside className="w-64 bg-padua-green text-white hidden md:flex flex-col">
        <div className="p-6 border-b border-white/10">
          <h1 className="font-cinzel text-xl text-padua-gold font-bold">Admin Center</h1>
          <p className="text-xs text-white/60 mt-1">Padua Local iPad System</p>
        </div>
        <nav className="flex-1 py-4 flex flex-col space-y-1 px-3">
          <AdminNavButton to="/admin/guests" icon={<FiUsers />} label="Guest Directory" />
          <AdminNavButton to="/admin/imports" icon={<FiDownload />} label="Import Guests" />
          <AdminNavButton to="/admin/audiences" icon={<FiActivity />} label="Follow-Up" />
          <AdminNavButton to="/admin/settings" icon={<FiSettings />} label="Settings" />
          <AdminNavButton to="/admin/system-check" icon={<FiHardDrive />} label="System Check" />
          
          <div className="mt-auto pt-4 border-t border-white/10">
            <AdminNavButton to="/" icon={<FiArrowLeft />} label="Back to Check-In" />
          </div>
        </nav>
      </aside>

      <main className="flex-1 overflow-auto">
        <header className="bg-white shadow-sm h-16 flex items-center px-8 md:hidden">
          <NavLink to="/" className="flex items-center text-padua-green font-medium">
            <FiArrowLeft className="mr-2" /> Back to Event
          </NavLink>
        </header>
        <div className="p-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

const AdminNavButton = ({ to, icon, label }) => (
  <NavLink 
    to={to} 
    className={({ isActive }) => `
      flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-all
      ${isActive ? 'bg-padua-gold text-white' : 'text-white/80 hover:bg-white/10'}
    `}
  >
    <span className="text-lg">{icon}</span>
    <span>{label}</span>
  </NavLink>
);